<template>
  <section class="flex align-middle justify-center sm:py-40">
    <Card class="w-448 max-w-screen p-24">
      <h1 class="text-h1 mb-16">{{ heading }}</h1>
      <template v-if="verificationEmailSent">
        <p class="pb-16 text-body text-grey-body">
          Please check your email at {{ workEmail }} to create your new, full-access account.
        </p>
      </template>
      <template v-else-if="manualFallback">
        <p class="pb-16 text-body text-grey-body">Our Customer Success team will review and verify your employer eligibility.</p>
        <p class="pb-16 text-body text-grey-body">
          You will receive an email at your entered work address within <strong>1–2 business days</strong> regarding your Premium
          upgrade.
        </p>
        <p class="pb-16 text-body text-grey-body">
          {{ meantimeCopy }}
        </p>
        <p class="pb-16 text-body text-grey-body">
          Questions? Reach out at
          <a href="mailto:support@sittercity.com" class="underline">support@sittercity.com</a>
        </p>
      </template>
      <p v-else class="pb-16 text-body text-grey-body">
        Our Customer Success team will validate your request. You will receive a confirmation email in 1-2 business days.
      </p>
      <Button
        id="continue-registration-btn"
        class="w-full"
        variant="primary"
        :value="continueButtonLabel"
        size="medium"
        :to="{ name: 'registration-care-type' }"
      />
    </Card>
  </section>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';
import { getItem, removeItem, STORAGE_KEYS } from '@/lib/storage';
import {
  getParentEmailVerificationPlacement,
  PARENT_PLACEMENT_ONBOARDING,
} from '@/apps/verifyEmail/helpers/parentPlacementPolicy';

const ONBOARDING_MEANTIME_COPY =
  "In the meantime, you can still share your care needs. After you verify your email, you can post a job and sitters can begin reaching out. You'll be able to respond once your account is upgraded.";

const DEFAULT_MEANTIME_COPY =
  "In the meantime, go ahead and share your care needs! Sitters can begin reaching out, and you'll be able to respond as soon as your account is upgraded.";

export default {
  name: 'UpgradeRequestSent',
  components: {
    Card,
    Button,
  },
  computed: {
    upgradePath(): string {
      return (this.$route.query.upgradePath as string) || 'manual';
    },
    workEmail(): string {
      return getItem(STORAGE_KEYS.CORPORATE_UPGRADE_WORK_EMAIL, 'session') || '';
    },
    verificationEmailSent(): boolean {
      return this.upgradePath === 'verification';
    },
    manualFallback(): boolean {
      return this.upgradePath === 'manual_fallback';
    },
    isOnboardingPlacement(): boolean {
      return getParentEmailVerificationPlacement() === PARENT_PLACEMENT_ONBOARDING;
    },
    heading(): string {
      return this.verificationEmailSent ? "We've confirmed your eligibility" : 'Upgrade request sent';
    },
    meantimeCopy(): string {
      return this.isOnboardingPlacement ? ONBOARDING_MEANTIME_COPY : DEFAULT_MEANTIME_COPY;
    },
    continueButtonLabel(): string {
      if (this.manualFallback) {
        return this.isOnboardingPlacement ? 'Continue' : 'Share my needs';
      }
      return this.verificationEmailSent ? 'Continue' : 'Continue signing up';
    },
  },
  beforeUnmount() {
    removeItem(STORAGE_KEYS.CORPORATE_UPGRADE_WORK_EMAIL, 'session');
  },
};
</script>
